import type { ComponentType } from 'react';
import { useSearchParams } from 'react-router-dom';

export const createPlanKeyedWrapper = (Component: ComponentType) => {
  const KeyedRoute = () => {
    const [searchParams] = useSearchParams();
    const planId = searchParams.get('plan_id');
    return <Component key={planId ?? 'no-plan'} />;
  };
  KeyedRoute.displayName = `PlanKeyed(${Component.displayName ?? Component.name ?? 'Component'})`;
  return KeyedRoute;
};
